/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnumDto } from './EnumDto';
export type RelationalCustomerProfileDetailDto = {
    /**
     * German name.
     */
    nameD?: string;
    /**
     * English name.
     */
    nameEN?: string;
    /**
     * Set profile type.
     */
    setProfileType: RelationalCustomerProfileDetailDto.setProfileType;
    /**
     * Set profile by age type.
     */
    setProfileByAgeType: RelationalCustomerProfileDetailDto.setProfileByAgeType;
    /**
     * Customer profile minimum age.
     */
    ageMin: number;
    /**
     * Customer profile maximum age.
     */
    ageMax: number;
    /**
     * Customer profile discound identifier.
     */
    discountId?: number;
    requireConfirmation: boolean;
    isic: boolean;
    /**
     * Application attachment types.
     */
    applicationAttachmentTypes?: Array<EnumDto>;
    /**
     * Date from which the entity is valid.
     */
    validFrom: string;
    /**
     * Customer profile identifier. Type: 'UUID'
     */
    id: string;
    /**
     * Customer profile name.
     */
    name: string;
    /**
     * Customer profile number.
     */
    profileNumber: number;
};
export namespace RelationalCustomerProfileDetailDto {
    /**
     * Set profile type.
     */
    export enum setProfileType {
        NOT_ALLOWED = 'NOT_ALLOWED',
        ALLOWED = 'ALLOWED',
        SPECIAL_WORKPLACE_ONLY = 'SPECIAL_WORKPLACE_ONLY',
    }
    /**
     * Set profile by age type.
     */
    export enum setProfileByAgeType {
        AUTOMATIC = 'AUTOMATIC',
        NOT_AUTOMATIC = 'NOT_AUTOMATIC',
    }
}

